import { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Amplify, { API, Auth, graphqlOperation } from "aws-amplify";
import { notification } from "antd";
import Swal from "sweetalert2";

import awsExports from "./aws-exports";

import Login from "./components/Login/login.js";
import Home from "./components/Home/home.js";
import DataPrivacy from "./components/Register/dataPrivacy.js";
import Verify from "./components/Verify/verify.js";
import PendingHome from "./components/Home/pendingHome.js";
import ZauOrderofPayment from "./pages/LC Order of Payment/OPPrint";
import COEFormPrint from "./pages/COE Form/COEFormPrint";
import SUPFormPrint from "./pages/SUP Form/SUPFormPrint";
import ChangePassword from "./components/Login/changePassword";

import LCFormPrint from "./pages/LC Form/LCFormPrint";
import PrintReport from "./print/PrintReport.jsx"

import { listUsers } from "./graphql/queries";
import { createUser } from "./graphql/mutations";

import "./App.css";
import "antd/dist/antd.css";

Amplify.configure(awsExports);

let tokenRefreshCount = 0; // Counter for token refreshes

const App = () => {
  const [regState, setRegState] = useState("");
  const [user, setUser] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const dataFetchedRef = useRef(false);

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(true);
      Swal.close(); // Close the Swal dialog if it was previously shown
    };

    const handleOfflineStatus = () => {
      setIsOnline(false);
      Swal.fire({
        icon: "error",
        title: "Offline",
        text: "You are offline. Please check your internet connection",
      }).then(() => {
        window.location.reload();
      });
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, []);

  const checkRefreshTokenExpiration = async () => {
    const issued_time = localStorage.getItem('refresh_token_issued_time')
   

    if (issued_time) {
      const userLoggedIn = localStorage.getItem('profile')
      if (userLoggedIn) {
        checkAuthStatus()
      }

      const now = new Date()
      const time_elapsed = parseInt(now - new Date(issued_time)) / 1000 //time elapsed in seconds
      const tenMinutesBeforeExpire = 10 * 60 //ten minutes in seconds
      const fiveMinutesBeforeExpire = 5 * 60 //five minutes in seconds
      const threeMinutesBeforeExpire = 3 * 10 // three minutes in seconds
      const expireHour = 60 * 2 * 60 //2 hours in seconds
      const remainingTime = expireHour - time_elapsed // remaining time in seconds

      if (remainingTime <= tenMinutesBeforeExpire) {
        if (remainingTime <= fiveMinutesBeforeExpire) {
          if (remainingTime <= threeMinutesBeforeExpire) {
            if (remainingTime >= 1) {
              notification['error']({
                message: 'Danger',
                duration: null,
                description: `Your session will expire in ${Math.floor(
                  remainingTime / 60
                )} minutes. The page will reload immediately after that time. Please finish your work or save it.`,
              })
            } else {
              if (userLoggedIn) {
                checkAuthStatus()
              }
            }
          } else {
            notification['info']({
              message: 'Info',
              duration: null,
              description: `Your session will expire in ${Math.floor(
                remainingTime / 60
              )} minutes. Please finish your work or save it.`,
            })
          }

          let count = 0
          const intervalId = setInterval(() => {
            if (userLoggedIn) {
              checkAuthStatus()
            }
            count++
            if (count === 10) {
              clearInterval(intervalId)
            }
          }, 30000)
        }
      }
    }
  }

  const checkAuthStatus = async () => {
    try {
      // this will check current session, throws an error if no valid session
      // this will update the access token previously saved after login the first time in the local storage
      // const user = await Auth.currentAuthenticatedUser();
      const session = await Auth.currentSession();

      localStorage.setItem("token", session.accessToken.jwtToken)
   

  
    } catch (err) {

      console.log(err)
    

      if (err === 'No current user') {
        // notify that user will be logged out
        notification['error']({
          message: 'Error',
          description:
            'Your session has expired. You will be logged out shortly.',
        })

        localStorage.clear()

        setTimeout(() => {
          window.location.reload()
        }, 4000)
      }

      if (err.code) {
        if (err.code === 'NotAuthorizedException') {
          console.log('User session has expired. Redirecting to sign-in page.')

          // notify that user will be logged out
          notification['error']({
            message: 'Error',
            description:
              'Your session has expired. You will be logged out shortly.',
          })

          localStorage.clear()

          setTimeout(() => {
            window.location.reload()
          }, 4000)
        }
      } else if (err.message) {
        if (err.message.toLowerCase().includes('refresh token')) {
          console.log('User session has expired. Redirecting to sign-in page.')

          // notify that user will be logged out
          notification['error']({
            message: 'Error',
            description:
              'Your session has expired. You will be logged out shortly.',
          })

          localStorage.clear()

          setTimeout(() => {
            window.location.reload()
          }, 4000)
        }
      }
    }
  }



  useEffect(() => {

    const issued_time = localStorage.getItem('refresh_token_issued_time')

    if (issued_time) {

      const now = new Date();

      const time_elapsed = now.getTime() - new Date(issued_time).getTime();

      const toCheck = 300000 - (time_elapsed % 300000);

      const timeoutId = setTimeout(() => {

        checkRefreshTokenExpiration();

        const interval = setInterval(checkRefreshTokenExpiration, 300000)

        return () => clearInterval(interval)

      }, 300000)

      return () => clearTimeout(timeoutId)
    }

    const interval = setInterval(checkRefreshTokenExpiration, 300000)

    return () => clearInterval(interval)

  }, [])

   // Function to refresh the token on demand
   
  //  const refreshTokens = async () => {
  //   try {
  //     const cognitoUser = await Auth.currentAuthenticatedUser();
  //     if (!cognitoUser) {
  //       console.log('User not authenticated');
  //       return;
  //     }
  //     const currentSession = await Auth.currentSession();
  //     if (!currentSession || !currentSession.refreshToken) {
  //       console.log('No current session or refreshToken');
  //       return;
  //     }
  //     cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
  //       if (err) {
  //         console.log('Error refreshing session:', err);
  //       } else {
  //         // Extract the necessary tokens from the refreshed session
  //         const { accessToken } = session;
  //         // Perform necessary operations with the refreshed tokens
  //         localStorage.setItem('token', accessToken.jwtToken);
  //       }
  //     });
  //   } catch (error) {
  //     console.log('Error refreshing token:', error);
  //   }
  // };
  
  // // Call the refreshTokens function every 10 minutes
  // useEffect(() => {
  //   const intervalJob = setInterval(refreshTokens, 2000); // 10 minutes interval
  
  //   // Clean up the interval on component unmount
  //   return () => clearInterval(intervalJob);
  // }, []); // Empty dependency array ensures the effect runs only once




  async function signUp(e) {
    const username = e.employeeUsername;
    const password = e.employeePassword;
    const fname = e.fname;
    const mname = e.mname;
    const lname = e.lname;
    const division = e.division;
    const role = e.role;
    const status = "Pending";
    const signature = e.signature;
    const captcha = e.captcha;

    try {
      const { user } = await Auth.signUp({
        username,
        password,
        attributes: {
          given_name: fname,
          middle_name: mname,
          family_name: lname,
          email: username,
          "custom:role": role,
          "custom:status": status,
          "custom:division": division,
          "custom:signature": signature,
          "custom:captcha": captcha,
        },
      });

      if (user) {
        localStorage.setItem("email", username);
        notification["success"]({
          message: "Success",
          description: "Verification code has been sent to your email.",
        });

        setTimeout(() => {
          window.location.pathname = "/verify";
        }, 3000);
      }
    } catch (error) {
      setRegState("");
      setRegState(error.message);

      notification["error"]({
        message: "Error",
        description: error.message,
      });
    }
  }

  async function confirmNow(e) {
    const username = e.email;
    const code = e.code;

    try {
      await Auth.confirmSignUp(username, code);
      notification["success"]({
        message: "Success",
        description: "Your account was verified. Please login to continue.",
      });
      setTimeout(() => {
        window.location.pathname = "/login";
        setRegState("");
        setRegState("successConfirm");
      }, 3000);
    } catch (error) {
      setRegState("");
      setRegState(error.message);
      notification["error"]({
        message: "Error",
        description: error.message,
      });
    }
  }

  async function logout() {
    Auth.signOut().then(() => {
      setUser(null);
      setTimeoutId(null);
      window.location.reload();
      localStorage.clear();
    });
  }

  async function signOut() {
    try {
      if (Auth?._storage?.length) {
        await Auth.signOut({ global: true });
        localStorage.clear();
        window.location.reload();
      } else {
        localStorage.clear();
        window.location.reload();
      }
    } catch (error) {
      notification["error"]({
        message: "Error",
        description: error.message,
      });
    }
  }

  async function signIn(e) {
    const { username, password } = e;

    try {
      const user = await Auth.signIn(username, password);

      if (user) {
        const issued_time = new Date().toISOString(); // get the current time in ISO format
        localStorage.setItem("refresh_token_issued_time", issued_time);

        const email = user.attributes.email;
        const d = user.attributes;

        API.graphql(
          graphqlOperation(listUsers, {
            limit: 1000,
            filter: { username: { contains: email } },
          })
        ).then((res) => {
          const emailFind = res.data.listUsers.items;

          if (emailFind.length) {
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("isLogin", true);
            localStorage.setItem(
              "token",
              user.signInUserSession.accessToken.jwtToken
            );
            localStorage.setItem("role", emailFind[0].role);
            localStorage.setItem(
              "name",
              `${user.attributes.given_name} ${user.attributes.family_name} `
            );

            localStorage.setItem("status", emailFind[0].status);
            localStorage.setItem("profile", JSON.stringify(emailFind[0]));
           
            if (emailFind[0].status === "Pending") {
              notification["success"]({
                message: "Success",
                description:
                  "Credentials accepted. Please wait for the admin approval",
                // duration: 5,
              });
              setTimeout(() => {
                window.location.pathname = "/home";
              }, 3000);
            } else if (emailFind[0].status === "Disabled") {
              notification["error"]({
                message: "Error",
                description: "You account has been disabled.",
                // duration: 5,
              });
              signOut();
            } else {
              notification["success"]({
                message: "Success",
                description: `Credentials accepted. Welcome ${emailFind[0].fname}`,
                // duration: 5,
              });
              setTimeout(() => {
                window.location.pathname = "/";
              }, 3000);
            }
          } else {
            API.graphql(
              graphqlOperation(createUser, {
                input: {
                  fname: d.given_name,
                  mname: d.middle_name,
                  lname: d.family_name,
                  role: d["custom:role"],
                  division: d["custom:division"],
                  status: "Pending",
                  username: d.email,
                  signatureLoc: d["custom:signature"]
                    ? d["custom:signature"]
                    : "no signature",
                },
              })
            ).then((createdUse) => {
              notification["success"]({
                message: "Success",
                description: `Credentials accepted. Welcome ${createdUse.data.createUser.fname}`,
                duration: 5,
              });
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("isLogin", true);
              localStorage.setItem(
                "token",
                user.signInUserSession.accessToken.jwtToken
              );
              localStorage.setItem(
                "profile",
                JSON.stringify(createdUse.data.createUser)
              );
              localStorage.setItem("role", user.attributes["custom:role"]);
              localStorage.setItem(
                "name",
                `${user.attributes.given_name} ${user.attributes.family_name} `
              );
              localStorage.setItem(
                "status",
                JSON.stringify(createdUse.data.createUser.status)
              );

              setTimeout(() => {
                window.location.pathname = "/home";
              }, 4000);
            });
          }
        });
      }
    } catch (error) {
      notification["error"]({
        message: "Error",
        description: error.message,
      });
      setRegState("");
      setRegState(error.message);
    }
  }

  return (
      <Router>
        <Routes>
          <Route exact path="/" element={<Home logout={signOut} />} />
          <Route path="/home" element={<PendingHome logout={signOut} />} />
          <Route
            path="/login"
            element={<Login signIn={signIn} regState={regState} />}
          />
          <Route
            path="/changePassword"
            element={
              <ChangePassword
                signUp={signUp}
                regState={regState}
              />
            }
          />
          <Route
            path="/verify"
            element={<Verify verify={confirmNow} regState={regState} />}
          />
          <Route path="/dataPrivacy" element={<DataPrivacy />} />
          <Route exact path="/lc-form-print" element={<LCFormPrint />} />
          <Route
            exact
            path="/orderofpaymentzau-form-print"
            element={<ZauOrderofPayment />}
          />
          <Route exact path="/coe-form-print" element={<COEFormPrint />} />
          <Route exact path="/sup-form-print" element={<SUPFormPrint />} />
          <Route exact path="/print-report" element={<PrintReport />} />
        </Routes>
      </Router>
  );
};

export default App;
